module.exports = __webpack_public_path__ + "img/zhengwu.6e1b6144.png";